<template>
  <div>
    <nav class="navbar is-light" role="navigation" aria-label="main navigation">

      <div class="navbar-brand">
        <a class="navbar-item" @click="route('projects')">
          <img src="../assets/logo.png" alt="HelixChart">
        </a>
      </div>

        <div class="navbar-end">
          <div class="navbar-item">
             <b-dropdown position="is-bottom-left">
                <a class="navbar-item" slot="trigger">
                  <span>{{ currentUser.email }} &nbsp;</span>
                  <i class="fa fa-caret-down"></i>
                </a>
                <b-dropdown-item @click="route('projects')">
                  <i class="fa fa-cube"></i>&nbsp;
                  Projects
                </b-dropdown-item>
                <b-dropdown-item @click="route('settings')">
                  <i class="fa fa-gears"></i>&nbsp;
                  Settings
                </b-dropdown-item>
                <b-dropdown-item disabled @click="route('subscription')">
                  <i class="fa fa-credit-card"></i>&nbsp;
                  Manage Subscription
                </b-dropdown-item>
                <b-dropdown-item disabled>
                  <i class="fa fa-users"></i>&nbsp;
                  Teams
                </b-dropdown-item>
                <hr class="dropdown-divider">
                 <b-dropdown-item href="http://helixchart.com">
                  <i class="fa fa-question-circle"></i>&nbsp;
                  About HelixChart
                </b-dropdown-item>
                <b-dropdown-item value="logout" @click="logout">
                  <i class="fa fa-sign-out"></i>&nbsp;
                  Logout
                </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>

    </nav>

  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'Navigation',
  data() {
    return {
      currentUser: {
        email: null,
      },
    };
  },
  mounted() {
    this.currentUser = firebase.auth().currentUser;
  },
  methods: {
    route(location) {
      this.$router.replace(location);
    },
    logout() {
      firebase.auth().signOut().then(() => {
        this.$router.replace('login');
        this.$toast.open({
          message: 'Successfully logged out!',
          position: 'is-bottom',
          type: 'is-success',
        });
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue